<template>
  <div id="videos">
    <Navbar current="Videos da home" />
    <Sidebar />
    <Container col="col-12">
      <Header title="Videos da home" :isSubHeader="false" subtitle="Videos da home dos aplicativos"
        :iconClass="'fa-solid fa-film text-primary'" :totalCount="totalItemsRegistered" :btnLink="$paths.videos.add"
        btnLabel="Adicionar" btnIcon="fa-solid fa-circle-plus" />
      <div class="card">
        <SearchBar @onSearch="search" />
        <LoadingContainer v-if="loadingItems" />
        <div v-else>
          <EmptyState v-if="!items.length" :totalItemsRegistered="totalItemsRegistered">
            <template v-slot:noItemsRegistered>
              <span class="fa-3x fa-solid fa-user-cog text-black-50 mb-2"></span>
              <p>Nenhum video criado</p>
            </template>
          </EmptyState>
          <div v-else class="table-responsive">
            <table ref="myTable" class="table table-sm table-nowrap card-table table-hover cursor-pointer">
              <TableHead :columns="columns" v-on:sort="sort" />
              <tbody class="list">
                <tr v-for="(item, index) in items" v-bind:key="'tr-' + index" @click="handleDetail(item.id, index)">
                  <td>
                    <img :src="item.formatted_thumbnail" alt="" class="avatar rounded w-auto">
                  </td>
                  <td >
                    {{ item.description }}
                  </td>
                  <td class="text-end">
                    <img :src="item.target_image" alt="" class="avatar rounded avatar-xs">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row" v-if="!loadingItems">
        <div class="col-12 text-end">
          <span class="text-muted">mostrando <b>{{ countItemsShowing }}</b> de
            <b>{{ countItemsTotal }}</b> resultado(s)</span>
        </div>
      </div>
      <div class="row justify-content-center" v-if="!loadingItems && moreItemsToLoad">
        <div class="col-2">
          <FormButton label="Carregar mais" :loading="loadingMoreItems" @onClick="loadMore" />
        </div>
      </div>
    </Container>
  </div>
</template>
<script>
import VideosController from "./VideosController";
export default VideosController;
</script>
